import Button from "components/Button";
import WhiteText from "components/WhiteText";
import { setSelectedSubscription } from "features/slices/reservationFlowSlice";
import { SubscriptionDetails } from "features/types";
import { useAppDispatch } from "hooks/useAppDispatch";
import i18n from "plugins/localization";
import { useFetchTenantConfigurationQuery } from "queries/configuration.queries";
import React from "react";
import { View } from "react-native";
import { formatCurrency } from "utils/appUtils";
import { toScehdule } from "utils/navigationUtils";
import { getPlanType } from "utils/planPackageUtils";
import { getUniqSubscriptions } from "utils/subscriptionUtils";
import ReservationDetails from "./ReservationDetails";
import { VoucherSubDetails } from "./VoucherDetails";

interface Props {
  accountSubscriptions: SubscriptionDetails[];
  accountBankSubscription: SubscriptionDetails;
  bankBalance: string | number;
}
const BankDetails: React.FC<Props> = (props) => {
  const { accountSubscriptions, accountBankSubscription, bankBalance } = props;
  const showBankBalance =
    accountBankSubscription.planPackage.showBankBalance ?? true;

  const dispatch = useAppDispatch();
  const { data: tenantConfig } = useFetchTenantConfigurationQuery();

  const childSubs = getUniqSubscriptions(accountSubscriptions).filter(
    (sub) =>
      sub.planPackage.parentId === accountBankSubscription.planPackage.id,
  );

  const childReservationSubs = childSubs.filter(
    (sub) => getPlanType(sub.planPackage) === "RESERVATION",
  );
  const childVoucherSubs = childSubs.filter(
    (sub) => getPlanType(sub.planPackage) === "VOUCHER",
  );

  return (
    <View>
      <View className="border border-white rounded-xl p-4 mb-4">
        <WhiteText category="h6">
          {showBankBalance
            ? `${accountBankSubscription.planPackage.name} Balance: `
            : accountBankSubscription.planPackage.name}
        </WhiteText>

        {showBankBalance ? (
          <View className="flex-row justify-between">
            <WhiteText style={{ fontSize: 36, fontWeight: "700" }}>
              {
                formatCurrency(bankBalance, {
                  priceType: tenantConfig?.bankPriceType,
                  showPoints: false,
                }) as string
              }{" "}
              {/* Home Screen - If Bank = dollar, do not show "points" */}
              <>
                {tenantConfig !== undefined &&
                tenantConfig.bankPriceType === "POINTS" ? (
                  <WhiteText category="p2">
                    {i18n.t("common.point", { count: Number(bankBalance) })}
                  </WhiteText>
                ) : null}
              </>
            </WhiteText>
            {accountBankSubscription.planPackage.ctaButtonText && (
              <Button
                appearance="outline"
                style={{ alignSelf: "flex-end" }}
                onPress={() => {
                  dispatch(setSelectedSubscription(accountBankSubscription));
                  toScehdule();
                }}
                size="small"
              >
                {accountBankSubscription.planPackage.ctaButtonText}
              </Button>
            )}
          </View>
        ) : (
          accountBankSubscription.planPackage.ctaButtonText && (
            <Button
              appearance="outline"
              style={{ alignSelf: "flex-end" }}
              onPress={() => {
                dispatch(setSelectedSubscription(accountBankSubscription));
                toScehdule();
              }}
              size="small"
            >
              {accountBankSubscription.planPackage.ctaButtonText}
            </Button>
          )
        )}
      </View>
      {(childReservationSubs.length > 0 || childVoucherSubs.length > 0) && (
        <>
          <ReservationDetails
            memberReservationSubs={childReservationSubs}
          ></ReservationDetails>

          {childVoucherSubs.map((sub) => (
            <View
              className="border border-white rounded-xl p-4 mb-4"
              key={sub.id}
            >
              {/**If a Bank plan has a voucher plan as its child, we want to show the details for the child voucher plan
               * do this by setting the isParent flag to true
               */}
              <VoucherSubDetails
                isParent
                currentSub={sub}
                accountVoucherSubs={childVoucherSubs}
                showCta
              ></VoucherSubDetails>
            </View>
          ))}
        </>
      )}
    </View>
  );
};

export default BankDetails;
